App.service('fileResponse', function(){
  return {
    download(response, default_filename){
      contentDispositionHeader = response.headers('Content-Disposition')
      if (contentDispositionHeader) {
        filename_from_header = contentDispositionHeader.match(/filename\*?="?(?:UTF-\d['"]*)?([^;\r\n"']*)"?;?/)
      } else {
        filename_from_header = null
      }
      if (filename_from_header) {
        filename = filename_from_header[1].replace(/"/g, '')
      } else {
        filename = default_filename
      }
      blob = new Blob([response.data], { type: 'text/csv' })
      anchor = document.createElement("a")
      anchor.download = filename
      anchor.href = window.URL.createObjectURL(blob)
      anchor.click()
    }
  }
})
